// 메뉴 스타일 정의
export const menuBoxStyle = {
  position: 'absolute',
  zIndex: 3000,
  background: '#fff',
  border: '1px solid #eee',
  boxShadow: '0 4px 16px rgba(0,0,0,0.07)',
  borderRadius: 8,
  minWidth: 180,
  padding: 0,
  margin: 0,
  listStyle: 'none',
  fontSize: 13,
  color: '#222',
};

export const menuItemStyle = {
  padding: '8px 16px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  border: 'none',
  background: 'none',
  width: '100%',
  textAlign: 'left',
  fontSize: 13,
  transition: 'background 0.15s',
  margin: 0,
  gap: 8,
};

export const menuItemHoverStyle = {
  background: 'rgba(25, 118, 210, 0.08)',
};

export const editInputStyle = {
  flex: 1,
  fontSize: 13,
  padding: '6px 8px',
  border: '1px solid #ccc',
  borderRadius: 4,
  outline: 'none'
};

export const saveButtonStyle = {
  fontSize: 13,
  padding: '6px 12px',
  borderRadius: 4,
  border: 'none',
  background: '#1976d2',
  color: '#fff',
  cursor: 'pointer',
  fontWeight: 500
};

export const editContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '8px 16px',
  width: '100%',
  boxSizing: 'border-box'
}; 